export default __webpack_public_path__ + "88999cea8a08391aab1dbb23a2567f16.svg";